import { PayoutMethod } from '..'
import { Capabilities } from '../entity'
import { typeChecker } from './type-checker'

export const getAllowedCapabilities = (payoutMethod: PayoutMethod) => {
  if (typeChecker.isEFT(payoutMethod)) return [Capabilities.RENTAL, Capabilities.INVESTMENT]
  if (typeChecker.isACH(payoutMethod)) return [Capabilities.RENTAL]
  else return []
}
